import { createSlice } from "@reduxjs/toolkit";

export interface UserIpDetails {
  ip: string;
  continent: string;
  country: string;
  region: string;
  city: string;
  postal: string;
  loc: string;
  hostname: string;
  connection: string;
  asname: string;
  as: string;
  organization: string;
  usageType: string;
  domain: string;
  route: string;
  languages: Array<{
    name: string;
    native: string;
    code: string;
  }>;
  currency: {
    name: string;
    code: string;
    symbol: string;
    native: string;
    plural: string;
  };
  calling_code: string;
  time_zone: {
    name: string;
    abbr: string;
    offset: string;
    is_dst: boolean;
    current_time: string;
  };
}

const initialState: UserIpDetails | null = null;

export const userIpDetailsSlice = createSlice({
  name: "userIpDetails",
  initialState,
  reducers: {
    setUserIpDetails: (state, action) => {
      return action.payload;
    },
    clearUserIpDetails: () => {
      return null;
    },
  },
});

export const { setUserIpDetails, clearUserIpDetails } = userIpDetailsSlice.actions;

export default userIpDetailsSlice.reducer;
